import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native';

import Colors from '../../constants/Colors';

import { AppText } from '../AppText';
import { AppTextInput } from '../AppTextInput';

const styles = StyleSheet.create({
  inputContainer: {
    position: 'relative',
    flexDirection: 'row',
    backgroundColor: Colors.primaryColor,
    height: 56,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  innerContainer: {
    borderWidth: 1,
    borderColor: Colors.inputGrayBorder,
    width: '100%',
    backgroundColor: 'white',
    height: 40,
    borderRadius: 16,
    paddingLeft: 8,
    paddingRight: Platform.OS === 'web' ? 8 : 0,
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowOffset: { width: 4, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 8,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputField: {
    height: 40,
    fontSize: 16,
    paddingVertical: Platform.OS === 'web' ? 12 : 0,
    borderWidth: 0,
    flexGrow: 1,
  },
  inputFieldWithClear: {
    paddingRight: 40,
  },
  clearButton: {
    position: 'absolute',
    right: 12,
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
  },
  clearButtonText: {
    fontSize: 24,
    color: Colors.grayText,
    fontWeight: '300',
  },
  icon: {
    fontSize: 20,
    color: Colors.grayText,
    paddingTop: 8,
  },
});

function PlentifulComponent(props) {
  const { translation, searchTerm, onSearchChange } = props;
  const [searchText, setSearchText] = useState('');
  const inputRef = useRef(null);
  const debounceTimeoutRef = useRef(null);

  // Keep searchText in sync with props
  useEffect(() => {
    setSearchText(searchTerm || '');
  }, [searchTerm]);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const searchPantries = (searchString) => {
    setSearchText(searchString);

    // Clear existing timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Debounce the callback
    debounceTimeoutRef.current = setTimeout(() => {
      if (onSearchChange) {
        onSearchChange(searchString);
      }
    }, 400);
  };

  const clearSearch = () => {
    searchPantries('');
    inputRef.current?.focus();
  };

  return (
    <View style={[styles.inputContainer]} testID="search-bar">
      <View style={[styles.innerContainer]}>
        <AppTextInput
          ref={inputRef}
          // Search bar lives in a fixed-height (56px) header; supporting scaled
          // text here will need a header redesign. Tracked with #3643.
          allowFontScaling={false}
          placeholder={translation.search}
          placeholderTextColor={Colors.grayText}
          style={[styles.inputField, searchText.length > 0 && styles.inputFieldWithClear]}
          onChangeText={(text) => {
            searchPantries(text);
          }}
          value={searchText}
          autoCorrect={false}
          returnKeyType="search"
          testID="search-input"
        />
        {searchText.length > 0 && (
          <TouchableOpacity style={styles.clearButton} onPress={clearSearch}>
            <AppText style={styles.clearButtonText}>ⓧ</AppText>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}

PlentifulComponent.propTypes = {
  translation: PropTypes.objectOf(PropTypes.any).isRequired,
  searchTerm: PropTypes.string,
  onSearchChange: PropTypes.func,
};

export default PlentifulComponent;
